import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faSpinner, faExclamationTriangle, faCloudUploadAlt, } from "@fortawesome/pro-solid-svg-icons";
import { Button } from "@perfectserve/library";
export const UploadStep = ({ isUploading, uploadError, hasPassedUpload, jobId, currentStep, onRetry, rowClassName, }) => {
    const getIcon = () => {
        if (currentStep === "uploading" && isUploading) {
            return _jsx(FontAwesomeIcon, { icon: faSpinner, spin: true });
        }
        if (uploadError) {
            return _jsx(FontAwesomeIcon, { icon: faExclamationTriangle });
        }
        if (hasPassedUpload) {
            return _jsx(FontAwesomeIcon, { icon: faCheckCircle });
        }
        return _jsx(FontAwesomeIcon, { icon: faCloudUploadAlt });
    };
    const getRightContent = () => {
        if (currentStep === "uploading" && isUploading) {
            return _jsx("span", { children: "Uploading..." });
        }
        if (uploadError) {
            return (_jsxs(_Fragment, { children: [_jsx("span", { children: uploadError }), _jsx(Button, { variant: "secondary", size: "small", onClick: onRetry, children: "Retry" })] }));
        }
        if (hasPassedUpload) {
            return _jsxs("span", { className: "auto-provisioning__job-id", children: ["Job ID: ", jobId] });
        }
        return _jsx("span", { className: "auto-provisioning__pending-text", children: "Waiting..." });
    };
    return (_jsxs("div", { className: `auto-provisioning__workflow-row ${rowClassName}`, children: [_jsxs("div", { className: "auto-provisioning__row-left", children: [getIcon(), _jsx("span", { className: "auto-provisioning__row-label", children: "Upload to Provisioning System" })] }), _jsx("div", { className: "auto-provisioning__row-right", children: getRightContent() })] }));
};
